import { Box, TextField, TextFieldVariants } from "@mui/material";
import { ChangeEvent, HTMLInputTypeAttribute } from "react";
import { FormTitle, IBaseLabelProps } from "../FormTitle/FormTitle";

interface ITextInputField {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  error?: boolean;
  inputType?: HTMLInputTypeAttribute;
  variant?: TextFieldVariants;
}
export const TextInputField = (props: ITextInputField & IBaseLabelProps) => {
  const {
    value,
    onChange,
    label,
    placeholder,
    hint,
    required,
    error,
    inputType = "text",
    variant = "standard",
    sx = {},
  } = props;

  return (
    <Box sx={{ mb: 2.5 }}>
      <FormTitle title={label} hint={hint} required={required} />
      <TextField
        sx={{ width: "100%", ...sx }}
        variant={variant}
        type={inputType}
        value={value}
        placeholder={placeholder}
        error={error}
        onChange={onChange}
      />
    </Box>
  );
};
